<template>
  <NextBtn
    :style="{ marginRight: '20px', color: '#150E8B', borderColor: '#150E8B' }"
    v-bind="$attrs"
    v-on="$listeners"
    ><slot></slot
  ></NextBtn>
</template>

<script>
import NextBtn from "@/components/NextBtn.vue";

export default {
  name: "CtaBtn",

  components: { NextBtn }
};
</script>
